import React, { useReducer, useRef, useEffect } from 'react';
import { i18nIntl, validateEmail, isArray, convertObjectToArray,getRemotedbUrl } from '../../lib/ep.js';
import { FormattedMessage, injectIntl } from 'react-intl';

import ActionButton, { BackButton, SecondaryButton } from '../builder/ActionButton';
import ActionLink from '../builder/ActionLink';
import ButtonCollection from '../builder/ButtonCollection.js';
import Checkbox from '../builder/Checkbox';
import { DeleteButton } from '../builder/ConfirmButton';
import DateTimePicker from '../builder/DateTimePicker';
import DisabledArea from '../builder/DisabledArea';
import DropzoneUploader from '../builder/DropzoneUploader';
import FieldLabel from '../builder/FieldLabel';
import FieldErrorMessage from '../builder/FieldErrorMessage';
import FilterModal from '../backend/FilterModal';
import Input from '../builder/Input';
import Model from '../builder/Model';
import SaveButton from '../builder/SaveButton';
import SectionTitle from '../builder/SectionTitle';
import Select from '../builder/Select';
import Spinner from '../builder/Spinner';
import FloatingLayer from '../builder/FloatingLayer';
import RichEditor from '../builder/RichEditor';

import { saveEmail } from './EmailsPlatform';
import { conditions as _conditions, subject_smartags, message_smartags, email_types } from './EmailFilter';
import { isMultiStage, stage_categories } from '../../data/bootstrap_stages';
import SectionSubtitle from '../builder/SectionSubtitle.js';
import Message from '../builder/Message.js';
import Tooltip from '../builder/Tooltip.js';
import Module from '../ui_items/Module.js';

const format_date = (window.is_spanish) ? 'DD-MM-YYYY' : 'YYYY-MM-DD';
const format_time = "HH:00";
const date_format_db = 'YYYY-MM-DD HH:00';

const FilterList = ({ email, state, dispatch, promotion, change, validate, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);
	const display_in_notification = email.notification == "1" ? true : false;

	const getConditionName = (condition) => {
		let filter_name = state.conditions.find((c) => c.key == condition.condition);

		//let name_condition = filter_name.v;
		let name_condition = filter_name?.name || 'Invalid Condition';
		if(condition.operator != '') {
			switch(condition.operator) {
				case '=':
				case 'equalto':
					name_condition += ' = ';
					break;

				case '<>':
				case 'different':
					name_condition += ' <> ';
					break;

				case '>':
				case 'greater':
					name_condition += ' > ';
					break;

				case 'less':
				case '<':
					name_condition += ' < ';
					break;

				case '>=':
				case 'greaterequal':
					name_condition += ' >= ';
					break;

				case '<=':
				case 'lessequal':
					name_condition += ' <= ';
					break;

				case 'REGEX':
				case 'regexp':
					name_condition += ' expreg ';
					break;

				case 'like':
					name_condition += ' ' + i18n("contains") + ' ';
					break;

				case 'every':
					name_condition += ' ' + i18n("each") + ' ';
					break;

				case '^':
					name_condition += ' ' + i18n("starts with") + ' ';
					break;
			}
		} else if(condition.value != '' && condition.value != undefined) {
			name_condition += ' = ';	//NO operator is equalto.
		}

		let cond = state.conditions.find((c) => c.key == condition.condition);

		if(cond){
			if(cond.humanize!=undefined)name_condition='';
			if((condition.value != "" || condition.value == "0") && condition.value != undefined) {
				name_condition += cond.humanize!= undefined ? cond.humanize(condition) : condition.value;
			}else if(cond.humanize!=undefined) name_condition = cond.humanize(condition);
		}
		return name_condition;
	};

	const _action = (props.action != undefined) ? props.action : false;
	const email_conditions = email?.config?.conditions || [];
	const display_type = props?.display_type || 'in_layer';

	let ul_classes = ['condition_list'];
	ul_classes.push((display_type == 'in_layer') ? 'gui_labels_selector' : 'bulleted_list gui_not_in_bottom');

	let label_no_conditions = i18n("No conditions.");
	if(display_in_notification) label_no_conditions += ' '+i18n("The notification is sent to all participants.");
	else {
		if([email_types.WIN_PRIZE,email_types.REJECT_PRIZE].includes(parseInt(email.type))){
			label_no_conditions += ' '+i18n("The use of a prize condition is mandatory to send this email.");
		}else{
			label_no_conditions += ' '+i18n("All participants will receive this email.");
		}
	}

	return (
		<>
			{(state.errorFilter) && (
				<FieldErrorMessage
					error_msg_position_class="gui_not_in_bottom_small"
					>{state.errorFilter}</FieldErrorMessage>
			)}

			<ul class={ul_classes.join(" ")}>
				{email_conditions.length > 0 && email_conditions.map((condition, i) => {
					return (
						<li key={`filter_${i}`}>
							{(display_type == 'in_layer') ? (
								<SecondaryButton
									onClick={() => props.deleteCondition(condition)}
									icon='knk-off'
									autotranslate={false}
								>{getConditionName(condition)}</SecondaryButton>
							) : (
								<span autotranslate={false}>{getConditionName(condition)}</span>
							)}
						</li>
					)
				})}

				{(email_conditions.length == 0) && ( <li>{label_no_conditions}</li> )}

				{(_action) && (
					<li>
						<ActionButton
							icon='knk-filter'
							onClick={_action}
						>Manage filters</ActionButton>
					</li>
				)}
			</ul>
		</>
	)
};

const EmailEdit = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const promotion = props.promotion;
	let email = props?.email || {};
	const max_files = 3;
	const max_file_size = 1;

	const display_in_notification = email.notification == "1" ? true : false;

	const saveMessage = useRef(false);

	useEffect(() => {

		let _conditions = email?.config?.conditions || [];
		if(_conditions.length == undefined){//is an object
			_conditions  = Object.values(_conditions);
		}

		//Many fix conditions
		_conditions.map((cond,i) => {
			switch(cond.condition){
				case 'language':
					_conditions[i].value = cond.customvalue ? [cond.customvalue] : cond.value;//From old emails
					break;
			}
		});
		email.config.conditions = _conditions;
	}, []);
	
	const change = async (k, v) => {
		if(k == 'datesend') v = v.format(date_format_db);
		if(k == 'status') v = v ? 1 : 0;
		
		if(k == 'stage_id'){
			let email_on_the_fly = email;
			email_on_the_fly.stage_id = v;
			dispatch({ type:'CHANGE', k:'subject_tags', v:subject_smartags(props.promotion,props.stages,props.prizes,email_on_the_fly)});
			dispatch({ type:'CHANGE', k:'message_tags', v:message_smartags(props.intl,props.promotion,props.cfs,props.stages,props.prizes,email_on_the_fly)});
			dispatch({ type:'CHANGE', k:'conditions', v:_conditions(props.intl,props.promotion,props.cfs,props.stages,props.prizes,email_on_the_fly,props.languages,props.segments)});
		}else if(k!='config'){
			validate(k);
		}
		if(props.change != undefined) props.change(email.id, k, v);
	};

	const changeConfig = async (k, v) => {
		let config = email?.config || [];
		if(k == 'recipient' && v == true){
			v = 'preset';
		}
		config[k] = v;
		await change('config', config);
		validate(`config.${k}`);
	};

	const addCondition = (new_condition) => {
		let configuration = { ...email.config };
		let conditions = configuration?.conditions || [];
		if(!existCondition(new_condition)) {
			conditions.push(new_condition);
			dispatch({ type:'SET_ERROR_FILTER', v:null});
			changeConfig('conditions', conditions);
			//validate('recipients');
		} else {
		//	alert("This filter already exists");
		}
	};

	const deleteCondition = (cond) => {
		let configuration = email.config;
		let conditions = configuration.conditions || [];
		conditions = conditions.filter((c) => {
			return JSON.stringify(c) !== JSON.stringify(cond);
		});
		dispatch({ type:'SET_ERROR_FILTER', v:null});
		changeConfig('conditions', conditions);
	};

	const existCondition = (new_c) => {
		let exist = false;
		const configuration = email.config;
		if(configuration.conditions) {
			(configuration.conditions).map((condition) => {
				if(new_c.condition == condition.condition && new_c.operator == condition.operator) {
					if(condition.value != undefined && new_c.value == condition.value) {
						exist = true;
					}
					exist = true;//Nomes permetem condicio amb operador diferent
				}
			});
		}

		return exist;
	};

	const transformFilterAndAddToConditions = (condition) =>{
		let filter = {};
		filter.condition = condition.filter.key;
		//filter.named_condition = condition.filter.name;
		filter.operator = condition.operator != undefined ? condition.operator : '=';
		let add_condition = true;
		switch(filter.condition){
			case 'created':
			case 'participations':
			case 'score':
			case 'total_score':
			case 'invitations':
			case 'ranking_position':
			case 'language':
			case 'public_entry':
			case 'prize_winners':
			case 'segment':
			case 'country':
			default:
				filter.value = condition.value;
				break;

			case 'prize_winners_no':
				filter.value = 'empty';
				break;

			case 'prize_winners_any':
				filter.value = 'not_empty';
				break;

			case 'custom_fields':
				let value = (condition.key).split('.');
				if(value.length > 1 && value[0] == 'CustomValue'){
					filter.id = value[1];
					filter.value = condition.value;
				} else {
					add_condition = false;
				}
				break;
		}
		if(add_condition)addCondition(filter);
	}

	const [state, dispatch] = useReducer((state, action) => {
		switch(action.type) {
			case 'SET_UPLOADING':
				return { ...state, uploading:action.uploading };

			case 'SET_ERROR_FILE':
				return { ...state, errorFile:action.errorFile };

			case 'SET_DISPLAY_NOT_SAVED_WARNING':
				return { ...state, not_saved_warning:action.not_saved_warning };

			case 'SET_ERRORS':
				return { ...state, errors:action.errors };

			case 'ADDFILTER':
				transformFilterAndAddToConditions(action.filter);
				return state;

			case 'CHANGE':
				return { ...state, [action.k]:action.v };

			case 'TOGGLE_FILTER':
				return { ...state, filter_modal:!state.filter_modal };

			case 'SET_ERROR_FILTER':
				return { ...state, errorFilter:action.v };

			default:
				return state;
		}
	}, {
		filter:{},
		errors:{},
		filter_modal:false,
		subject_tags:subject_smartags(props.promotion,props.stages,props.prizes,email),
		message_tags:message_smartags(props.intl,props.promotion,props.cfs,props.stages,props.prizes,email),
		uploading:false,
		show_filter:false,
		not_saved_warning:false,
		errorFile:null,
		errorFilter:null,
		conditions:_conditions(props.intl,props.promotion,props.cfs,props.stages,props.prizes,email,props.languages,props.segments)
	});

/*	useEffect(() => {
		if(!isNaN(props.email_id)) change('id', props.email_id);
	}, [props.email_id]);*/

	useEffect(() => {
		const __errors = state.errors;
		delete __errors['subject'];
		delete __errors['message'];
		dispatch({ type:'SET_ERRORS', errors:_errors });
	},[state.subject_tags,state.message_tags])

	useEffect(() => {
		
		let configuration = email.config;
		let conditions = configuration.conditions ?? [];

		if(conditions.length > 0){
			let new_conditions = [];
			const newconds = _conditions(props.intl,props.promotion,props.cfs,props.stages,props.prizes,email,props.languages,props.segments)
			conditions.map((cond,i)=>{
				const exist_condition = newconds.find((c) => c.key == cond.condition);
				if(exist_condition || cond.condition == 'ids'){
					new_conditions.push(cond);
				}
			});
			changeConfig('conditions', new_conditions);
		}

	}, [email.stage_id]);

	

	const validate = (field_changed) => {
		let _errors = state.errors != undefined ? state.errors :{};
		if(field_changed) {
			let splitted_for_error = field_changed.split('.');
			let field_name_for_error = (splitted_for_error.length > 1) ? splitted_for_error[1] : field_changed;
			delete _errors[field_name_for_error];
		}

		const _type = (email.type != undefined) ? props.emailTypes.find((em) => em.type == email.type) : false;
		let _fields = ['description', 'config.fromname', 'config.replyto', 'subject', 'message'];
		const _by_stage = _type.by_stage != undefined ?  _type.by_stage : false;
		
		if(isMultiStage(promotion.promotion_type_id) && _by_stage && email.stage_id)_fields.push('stage_id');
		if(_type.is_scheduled) _fields.push('datesend');
		
		_fields.map((f) => {
			let splitted_field = f.split('.');
			let field_name = (splitted_field.length > 1) ? splitted_field[1] : f;
			if(field_changed && f != field_changed) return false;
			const value = (splitted_field.length > 1) ? email[splitted_field[0]][field_name] : email[field_name];
			if(!value) _errors[field_name] = i18n("Mandatory field");
			if(f == 'stage_id'){
				const search_stage = (props.stages).find((st) => st.Stage.id ==  email[field_name]);
				if(!search_stage)_errors[field_name] = i18n("Stage not found");
			}
			var emojis_regex = /[\uD800-\uDFFF]/g;
			if(f == 'config.fromname' && emojis_regex.test(value)){
				_errors[field_name] = i18n("This field can't contain emojis");
			}

		});
		
		let _emails = [];
		if(_errors.email_notification != undefined) delete _errors.email_notification;
		if(display_in_notification) _emails.push('config.email_notification');

		if(_errors.bcc != undefined) delete _errors.bcc;
		if(email.config.bcc != undefined && email.config.bcc != '') _emails.push('config.bcc');
		
		//if(_errors.replyto != undefined) delete _errors.replyto;
		if(email.config.replyto != undefined && email.config.replyto != '') _emails.push('config.replyto');
		
		_emails.map((f) => {
			const splitted_email = f.split('.');
			const field_name = (splitted_email.length > 1) ? splitted_email[1] : f;
			if(field_changed && f != field_changed) return false;

			const value = (splitted_email.length > 1) ? email[splitted_email[0]][field_name] : email[field_name];
			const valid_email = validateEmail(value);
			if(!valid_email)_errors[field_name] = i18n("Invalid email format");
		});
		
		let conditions = email.config?.conditions || [];
		
		if(_errors['config.conditions']!=undefined)delete _errors['config.conditions'];
		if(email.type == email_types.RANKING_LOSE){
			let ranking_position_condition = conditions.find((c) => c.condition == 'ranking_position');
			if(!ranking_position_condition) {
				_errors['config.conditions'] = i18n("The condition of raking position is mandatory for this type of email");
			}
		}
		if([email_types.WIN_PRIZE,email_types.REJECT_PRIZE].includes(parseInt(email.type))){
			let prize_assignation_condition = conditions.find((c) => ['prize_assignation','prize_rejection'].includes(c.condition));
			if(!prize_assignation_condition){
				const label_type_email = (email.type == email_types.WIN_PRIZE) ?  i18n("Upon winning a prize") : i18n("Upon losing a prize");
				_errors['config.conditions'] = props.intl.formatMessage({ id:"The email {label} is subject to the use of prize conditions by assignment type." }, { label:`"${label_type_email}"` });;
			}
		}

		var subject_prize_smartag = (email.subject).match(/\{\{prize_[a-z\_]*\}\}/g);
		var message_prize_smartag = (email.message).match(/\{\{prize_[a-z\_]*\}\}/g);
		let prize_conditions = conditions.find((c) => c.condition.match(/prize_[a-z\_]*/g));

		if((subject_prize_smartag || message_prize_smartag) && !prize_conditions && !conditions_from_audience) {
			_errors['config.conditions'] = i18n("The use of the prize smart tags is subject to the use of prize conditions");
		}

		if(!_errors['config.conditions'] && [email_types.MANUAL,email_types.NEW_SCHEDULED].map(String).includes(String(email.type))) {
			var message_gallery_smartag = (email.message).match(/\{\{entry_gallery_link\}\}/g);
			let stage_gallery_condition = conditions.find((c) => c.condition == 'has_entry_gallery');

			if(message_gallery_smartag && !stage_gallery_condition){//Has content in a gallery
				_errors['config.conditions'] = props.intl.formatMessage({ id:"The use of the stage gallery link smartag is subject to the use of {condition} condition" }, { condition:`"${i18n("Has content in a gallery")}"` });
			}
		}
		
		if(!_errors['config.conditions']) {
			if(conditions.length > 0) {
				conditions.map((item) => {
					if(item.condition == 'ids')return null;//Created from audience and CONDITION no available to select in Recipients
					let found_valid_condition = (state.conditions).find((c) => c.key == item.condition);
					if(!found_valid_condition){
						_errors['config.conditions'] = i18n("Invalid condition");
						return null;
					}
				})
			}
		}
		

		const regex = RegExp('\{\{[a-zA-Z0-9\_\:]+\}\}', 'g');
		if(!_errors.subject) {
			const matches = email.subject != undefined ? email.subject.match(regex) : [];
			if(matches && matches.length > 0) {
				matches.map((match) => {
					let tag_search = match.replace(/[^a-zA-Z0-9\_]/g, '');
					let find = state.subject_tags.find((t) => t.tag == tag_search);
					if(!find) {
						_errors.subject = props.intl.formatMessage({ id:"{smartag} is an invalid smart tag" }, { smartag:`"${tag_search}"` });
						return true;
					}
				})
			}
		}

		if(!_errors.message) {
			const matches = email.message != undefined ? email.message.match(regex) : [];
			if(matches && matches.length > 0) {
				matches.map((match) => {
					let tag_search = match.replace(/[^a-zA-Z0-9\_\:]/g, '');
					let find = state.message_tags.find((t) => t.tag == tag_search);
					if(find == undefined) {
						_errors.message = props.intl.formatMessage({ id:"{smartag} is an invalid smart tag" }, { smartag:`"${tag_search}"` });
						return true;
					}
				})
			}
		}
		dispatch({ type:'SET_ERRORS', errors:_errors });
	};

	const save = (cb) => {
		validate();
		let errors = state.errors != undefined ? state.errors : {};
		if(Object.keys(errors).length == 0) {
			//Assign or not Stage ID
			if(email.type != email_types.REGISTER && email.type != email_types.NEW_SCHEDULED && email.type != email_types.MANUAL){
				if(!isMultiStage(promotion.promotion_type_id) && (email.stage_id == undefined || email.stage_id == null) && props.stages.length>0){
					change('stage_id',props.stages[0].Stage.id);
				}
			}
			saveEmail(promotion.id,email,(result) => {
				let errors = {};
				if(result.status == 1) {
					let feedback_msg = i18n("Changes saved");
					if(isNaN(email.id)){
						change('id',result.email.id);
						window.location.hash = `#edit/${result.email.id}`;
						feedback_msg = i18n("Email created");
					}
					EP.showSuccessSave();
				} else {
					errors = result.errors;
					dispatch({ type:'SET_ERRORS', errors});
					EP.showErrorSave()
				}
				if(cb != undefined) cb();
			});
			
		} else {
			if(cb != undefined) cb();
		}
	};

	let acceptedFiles_array = [
		'audio/*',
		'application/pdf',
		['image/jpeg', 'image/png', 'image/bmp', 'image/tiff', 'image/x-icon'],
	];

	const dropzone_ref = useRef(null);
	const initDropzone = (dropzone) => {
		dropzone_ref.current = dropzone;
	};

	var ReactDOMServer = require('react-dom/server');
	let properties_upload = {
		djsConfig:{
			addRemoveLinks:false,
			autoProcessQueue:true,
			parallelUploads:1,
			createImageThumbnails:true,
			maxFilesize:max_file_size,	//MB
			paramName:'file',
			timeout:30000,
			maxFiles:max_files,
			acceptedFiles:acceptedFiles_array.join(','),
			url:`/emails/upload/${promotion.id}`,
			previewTemplate:ReactDOMServer.renderToStaticMarkup(<div></div>)
		},

		componentConfig:{
			//iconFiletypes:['.jpg', '.png', '.gif'],
			//showFiletypeIcon:false,
			postUrl:`/emails/upload/${promotion.id}`,
		},

		eventHandlers:{
			init:(dropzone) => {
				initDropzone(dropzone);
			},

			addedfile:(file) => {
				// props.fileAdded(file);
				dispatch({ type:'SET_UPLOADING', uploading:true });
			},
	
			removedfile:(file) => {
			},
	
			uploadprogress:(file) => {
			},
	
			complete:(file) => {
				dispatch({ type:'SET_UPLOADING', uploading:false });
				completedFile(file);
			},
	
			addedfiles:(files) => {
			},
	
			error:(file) => {
				dispatch({ type:'SET_ERROR_FILE', errorFile:file });
				dropzone_ref.current.removeFile(file);
			},
		},
	};

	const completedFile = (file) => {
		const xhr_values = file?.xhr ?? false;
		if(xhr_values) {
			const result = JSON.parse(xhr_values.responseText);
			const new_file = {
				name:result.realname,
				file:result.filename,
				mime:result.mimetype,
				type:result.type_file,
			};

			const v = (email.attachments != undefined) ? [...email.attachments, new_file] : [new_file];
			change('attachments', v);
		}

		dropzone_ref.current.processQueue();
	};

	const deleteFile = (delete_file) => {
		let attachments = (email.attachments).filter((m) => m.file != delete_file.file);
		change('attachments', attachments);
	};

	const goBack = () => {
		if(isNaN(email.id)) {
			dispatch({ type:'SET_DISPLAY_NOT_SAVED_WARNING', not_saved_warning:true });
			return;
		}

		self.location.hash = email.notification == "1" ? '#notifications' : '#';
	};

	const deleteMailAndBack = () => {
		if(props.removeUnsavedEmails != undefined) {
			props.removeUnsavedEmails(email.id, () => {
				self.location.hash = '#';
			});
		} else {
			self.location.hash = '#';
		}
	};

	const accepted_types = ['Image', 'PDF'];	// 'Image', 'Video', 'PDF'
	const selected_type = (email.type != undefined) ? props.emailTypes.find((em) => em.type == email.type) : false;
	
	let tz = promotion.timezone;
	const min_date_schedule = moment.tz(promotion.start_date,"Europe/Madrid").tz(tz);
	const max_date_schedule = moment.tz(promotion.end_date,"Europe/Madrid").tz(tz).add(1, 'months');
	let datesend = email?.datesend || max_date_schedule;
	

	const total_medias = (email.attachments != 'no_file' && email.attachments != undefined) ? email.attachments.length : 0;
	const disabled_add_media = (state.uploading || total_medias >= max_files) ? true : false;
	const error_num_files = props.intl.formatMessage({ id:"You have already attached the {num_files} files allowed" }, { num_files:max_files });

	const sections = [{
		label:i18n("Users"),
		onClick:() => goToFilterArea('user'),
		selected:true,
	}];

	let email_conditions = email?.config?.conditions || [];
	email_conditions = !isArray(email_conditions) ? convertObjectToArray(email_conditions) : email_conditions;


	const loop_stages = selected_type.multimedia_content ? (props.stages).filter((st) => {return st.Stage.type == stage_categories.ID_MEDIA_CATEGORY.id}) : props.stages;
	
	let stages_arr = [];
		stages_arr.push({k:'', v: "All participation stages"});
	loop_stages.map((st) => {

		let title_stage = st.Stage?.display_title ?? `${i18n("Stage")}: #${st.Stage.id}`;
		if(st.Stage.type==stage_categories.ID_VOTING_CATEGORY.id) title_stage += `${st.Stage.voting_type == 'ponderated' ? ' ('+i18n("Advanced")+')' : ''}`
		return (
			stages_arr.push({
				k:st.Stage.id,
				v:title_stage
			})
		)
	});

	const subject_tags = state.subject_tags.filter((tag) => { return !tag.hide });
	const message_tags = state.message_tags.filter((tag) => { return !tag.hide });

	const conditions_from_audience = email_conditions.find((c) => c.condition == 'ids');
	const _errors = state?.errors || {};

	const has_errors = (Object.keys(_errors).length > 0) ? true : false;

	let sended_at = email.sended_at == undefined || email.sended_at.includes('0000') ? false : email.sended_at;
	const to_sent_in_bulk = (email.type == email_types.MANUAL || email.type == email_types.NEW_SCHEDULED) ? true : false;
	const blocked_email = to_sent_in_bulk && sended_at ? true : false;
	const _by_stage = selected_type.by_stage != undefined ?  selected_type.by_stage : false;
	
	return (
		<DisabledArea
			disabled={blocked_email}
			message="This email has already been sent and cannot be modified"
			_class={{other:'gui_pos_rel gui_grid'}}
		>
			<Module
				title={{
					label:`${(display_in_notification) ? i18n("Notification") : i18n("Email")}: ${i18n(selected_type.name)}`,
					icon:selected_type.icon,
					autotranslate:false,
				}}
				subtitle={selected_type.desc}
				actions={<>
					<BackButton
						onClick={goBack}
					/>
				</>}
			>
				<article>
					<Model model={email} change={change} errors={_errors}>
						<Input name="description" _class={{size:70}} placeholder="Example: Email to all participants on register" autotranslate={false}>{display_in_notification ? i18n("Name this notification") : i18n("Name this email")}</Input>

						{(isMultiStage(promotion.promotion_type_id) && _by_stage) && (
							<Select values={stages_arr} _class={{size:70}} name="stage_id">What stage does it apply to?</Select>
						)}

						{(selected_type.is_scheduled) && (
							<DateTimePicker
								_class={{size:70}}
								format={format_date}
								value={datesend}
								name="datesend"
								position="bottom-left"
								min_date={min_date_schedule}
								max_date={max_date_schedule}
								time_interval={60}
								time_format={format_time}
							>Sending date</DateTimePicker>
						)}
					</Model>

					{(display_in_notification) && (
						<Input name="email_notification" _class={{size:70}} model={email.config} change={changeConfig} errors={_errors}>Email address to send the notification to</Input>
					)}
				</article>

				{(!conditions_from_audience) && (
					<article class="gui_not_in_top_huge react_field">
						<div class={(_errors['config.conditions'] != undefined) ? 'has_error' : null}>
							<FieldLabel _class={{first:true}}>Conditions</FieldLabel>

							<div class="div_textarea">
								<p class="gui_not_in_bottom_small"><FormattedMessage id="The {type} is sent when the participant meets {conditions}" values={{type:display_in_notification ? i18n("notification") : i18n("email"), conditions:<u>{i18n("All these conditions", 'uppercase')}</u>}} />:</p>

								<FilterList
									email={email}
									state={state}
									dispatch={dispatch}
									promotion={promotion}
									change={change}
									deleteCondition={deleteCondition}
									validate={validate}
									stages={props.stages}
									display_type='visible'
									intl={props.intl}
								/>

								<ButtonCollection>
									<ActionLink onClick={() => dispatch({ type:'TOGGLE_FILTER' })} autotranslate={false}>{i18n((state.conditions.length > 0) ? "Edit conditions" : "Add conditions")}</ActionLink>
								</ButtonCollection>
							</div>

							{(_errors['config.conditions'] != undefined) && (
								<FieldErrorMessage autotranslate={false}>{_errors['config.conditions']}</FieldErrorMessage>
							)}
						</div>
						{(email.type == email_types.WIN_PRIZE && false) && (
							<p class="gui_not_in_top"><strong>{i18n("Note")}:</strong> {i18n("This email doesn't apply to prizes assigned through a random draw.")}</p>
						)}
					</article>
				)}

				{(conditions_from_audience) && (
					<Message>
						<p><FormattedMessage id="This email will be sent to {num_users} users selected from the list of participants." values={{num_users:conditions_from_audience.value.length }} /></p>
					</Message>
				)}

				{(state.filter_modal) && (
					<FilterModal
						filters={state.conditions}
						stateFilters={email_conditions}
						dispatch={dispatch}
						sections={sections}
						stages={props.stages}
						setError={(msg)=>dispatch({ type:'SET_ERROR_FILTER', v:msg })}
						toggle={() => dispatch({ type:'TOGGLE_FILTER' })}
					>	
						<FilterList
							email={email}
							state={state}
							dispatch={dispatch}
							promotion={promotion}
							change={change}
							deleteCondition={deleteCondition}
							validate={validate}
							stages={props.stages}
							intl={props.intl}
						/>
					</FilterModal>
				)}
			</Module>

			<Module title="Message">
				{(props.premium_fromemail) && (
					<div class="input type text _w60 knk-star yellowIcon">
						<label>{i18n("From email address")}</label>
						<strong class="not_in_top_low button_alike">{props.premium_fromemail}</strong>
					</div>
				)}

				<Model model={email.config} change={changeConfig} errors={_errors}>
					<Input
						name="fromname"
						_class={{size:80}}
						placeholder="Your Name"
					>From name</Input>

					<Input
						name="replyto"
						_class={{size:80}}
						label_props={{
							tooltip:<Tooltip>Email address that will be used in case the user replies directly to the email received. Important: This is not the sender's email address. The sender address 'From email' is not editable and comes with Easypromos domains to minimize spam.</Tooltip>,
						}}
					>Reply to</Input>

					<Input
						name="bcc"
						_class={{size:80}}
						label_props={{
							tooltip:<Tooltip>Send as BCC to another email address. We only accept 1 BCC per email.</Tooltip>,
						}}
					>BCC</Input>
				</Model>

				<Model model={email} change={change} errors={_errors}>
					<RichEditor
						has_emojis={true}
						enable_html={false}
						_class={{size:80, other:'small_textarea'}}
						name="subject"
						smarttags={subject_tags}
					>Subject</RichEditor>

					<RichEditor
						has_emojis={true}
						_class={{size:80, other:'x_textarea'}}
						name="message"
						smarttags={message_tags}
						buttons={true}
						enable_align={true}
					>Message</RichEditor>

					{(isNaN(email.id) && email.type != email_types.MANUAL) && (
						<Checkbox name="status" autotranslate={false}>
							<FormattedMessage
								id="Activate the sending of this {type}"
								values={{type:display_in_notification ? i18n("notification") : i18n("email")}}
							/>
						</Checkbox>
					)}
				</Model>

				{(!display_in_notification) && (
					<div class="gui_not_in_top_huge">
						<DisabledArea disabled={disabled_add_media} message={error_num_files} classname="gui_pos_rel fields_grouper">
							{(state.uploading) && (
								<Spinner
									_class={{fullscreen:false}}
									force_bg={true}
									style={{zIndex:'8'}}
								>Uploading file</Spinner>
							)}

							<DropzoneUploader
								key={`test_${total_medias}`}
								errors={_errors}
								name="attachments"
								dd_size="full_w"
								{...properties_upload}
								_accepted_formats={accepted_types}
								max_filesize={`${max_file_size} MB`}
							>Attach files</DropzoneUploader>
						</DisabledArea>

						{(total_medias > 0) && (
							<ul class="uploaded_files">
								{(email.attachments).map((file, f) => {
									if(!file)return null;
									return (
										<li key={`file_${f}`}>
											<DeleteButton
												_position="right"
												squared={true}
												onClick={() => deleteFile(file)}
											/>

											<strong>{file.name}</strong>
										</li>
									)
								})}
							</ul>
						)}
					</div>
				)}

				{(!blocked_email) && (
					<ButtonCollection _class={{other:'not_in_top'}}>
						<SaveButton
							disabled={has_errors}
							onClick={(!has_errors) ? (e, cb) => save(cb) : null}
							autotranslate={false}
							error={(has_errors) ? "There are errors. Please fix them before saving." : null}
						>{isNaN(email.id) ? i18n("Create") : i18n("Save")}</SaveButton>
					</ButtonCollection>
				)}

				{(state.errorFile) && (
					<FloatingLayer _class={{size:'small'}} backButton={() => dispatch({ type:'SET_ERROR_FILE', errorFile:null })}>
						<div class="without_actions">
							<SectionTitle>The uploaded file is not valid</SectionTitle>

							<SectionSubtitle autotranslate={false}>{i18n("The uploaded file is not valid")}: <strong>{state.errorFile.name}</strong></SectionSubtitle>

							<SectionSubtitle autotranslate={false}>{i18n("Valid formats")}: <strong>{accepted_types.join(", ")}</strong></SectionSubtitle>

							<SectionSubtitle autotranslate={false}>{i18n("Maximum file size allowed")}: <strong>{max_file_size} MB</strong></SectionSubtitle>
						</div>
					</FloatingLayer>
				)}

				{(state.not_saved_warning) && (
					<FloatingLayer _class={{size:'small'}} backButton={() => dispatch({ type:'SET_ERROR_FILE', errorFile:null })}>
						<div>
							<SectionTitle>The email is not saved</SectionTitle>

							<SectionSubtitle>Are you sure you want to leave this page?</SectionSubtitle>

							<ButtonCollection in_floating={true}>
								<SecondaryButton
									icon='knk-off'
									onClick={() => dispatch({ type:'SET_DISPLAY_NOT_SAVED_WARNING', not_saved_warning:false })}
								>No, continue editing</SecondaryButton>

								<ActionButton
									icon='knk-arrow-l-big'
									onClick={() => deleteMailAndBack()}
								>Yes, exit</ActionButton>
							</ButtonCollection>
						</div>
					</FloatingLayer>
				)}
			</Module>
		</DisabledArea>
	)
}

export default injectIntl(EmailEdit);